/**
 * Compatibility layer types for migrating from ngx-uploader to PrimeNG FileUpload
 * These types replicate the ngx-uploader API to maintain backward compatibility
 */

export interface UploadFile {
  id: string;
  fileIndex: number;
  lastModifiedDate: Date;
  name: string;
  size: number;
  type: string;
  form: FormData;
  progress: UploadProgress;
  response?: any;
  responseStatus?: number;
  responseHeaders?: { [key: string]: string };
  sub?: any;
  nativeFile?: File;
}

export interface UploadProgress {
  status: UploadStatus;
  data?: {
    percentage: number;
    speed: number;
    speedHuman: string;
    startTime: number | null;
    endTime: number | null;
    eta: number | null;
    etaHuman: string | null;
  };
}

export enum UploadStatus {
  Queue,
  Uploading,
  Done,
  Cancelled
}

export interface UploadOutput {
  type: 'addedToQueue' | 'allAddedToQueue' | 'uploading' | 'done' | 'start' | 'cancelled' | 'dragOver' | 'dragOut' | 'drop' | 'removed' | 'removedAll' | 'rejected';
  file?: UploadFile;
  nativeFile?: File;
}

export interface UploadInput {
  type: 'uploadAll' | 'uploadFile' | 'cancel' | 'cancelAll' | 'remove' | 'removeAll';
  url?: string;
  method?: string;
  id?: string;
  fieldName?: string;
  fileIndex?: number;
  file?: UploadFile;
  data?: { [key: string]: string | Blob };
  headers?: { [key: string]: string };
  includeWebKitFormBoundary?: boolean;
  concurrency?: number;
  withCredentials?: boolean;
}

export interface UploaderOptions {
  concurrency: number;
  allowedContentTypes?: string[];
  maxUploads?: number;
  maxFileSize?: number;
}

export class UploaderConfig {
  editMode?: boolean;
  uploadURL?: string;
  additionalData?: any;
  featureId?: number;
  businessId?: number;
  showUploadButton?: boolean;
  showDocumentedTrainingButton?: boolean;
  IsPrivateUploadButton?: boolean;
  IsDocumentedUploadButton?: boolean;
  title?: string;
  titleAsLabel?: boolean;
  windowedHeight?: boolean;
  allowedFileTypes?: string[];
  multiple?: boolean;
  auto?: boolean;
}

// Helper function to generate unique IDs
export function generateId(): string {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
}

// Helper function to format bytes
export function humanizeBytes(bytes: number): string {
  if (bytes === 0) {
    return '0 Byte';
  }
  const k = 1024;
  const sizes: string[] = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i: number = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
